import React from "react";
import { toast } from "sonner";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { suggestMapping } from "./csvAliases";
import CsvCampaignPicker from "./CsvCampaignPicker";
import CsvMappingTable from "./CsvMappingTable";

/**
 * Step 2 of the CSV wizard — field mapping + campaign/affiliate + test toggle.
 *
 * The mapping-table and campaign-picker UI live in dedicated sub-components
 * so the wizard step orchestrator stays a thin composition.
 */
export default function CsvMappingStep({
  preview, mapping, setMapping,
  campaigns, affiliates,
  campaignId, setCampaignId,
  affiliateId, setAffiliateId,
  forceTest, setForceTest,
  onBack, onApply, busy,
}) {
  const autoSuggest = () => {
    setMapping(suggestMapping(preview.headers, preview.canonical_fields));
    toast.info("Auto-suggested field mapping applied");
  };

  // Toggle one column's mapping; empty value removes the entry entirely
  // so the server doesn't see a stale key.
  const setOne = (h, value) => {
    const next = { ...mapping };
    if (value) next[h] = value;
    else delete next[h];
    setMapping(next);
  };

  return (
    <div className="brut-card mt-4 p-6 space-y-4" data-testid="wiz-step-2">
      <div className="text-sm">
        <span className="font-mono">{preview.row_count}</span> rows detected · {preview.headers.length} columns
      </div>

      <CsvCampaignPicker
        campaigns={campaigns} campaignId={campaignId} setCampaignId={setCampaignId}
        affiliates={affiliates} affiliateId={affiliateId} setAffiliateId={setAffiliateId}
      />

      <CsvMappingTable
        preview={preview} mapping={mapping}
        setOne={setOne} onAutoSuggest={autoSuggest}
      />

      <label className="inline-flex items-center gap-2 text-xs">
        <input type="checkbox" data-testid="csv-force-test"
          checked={forceTest} onChange={(e) => setForceTest(e.target.checked)} />
        <span className="uppercase tracking-widest">Import all rows as TEST leads</span>
      </label>

      <div className="flex justify-between pt-3 border-t border-black">
        <button onClick={onBack}
          className="border border-black px-3 py-2 text-xs uppercase tracking-widest">← Back</button>
        <button onClick={onApply} disabled={busy} data-testid="csv-apply"
          className="bg-black text-white border border-black px-4 py-2 uppercase text-xs tracking-widest font-bold hover:translate-x-[2px] hover:translate-y-[2px] hover:brut-shadow-sm transition-transform duration-100 disabled:opacity-60">
          {busy ? "Importing…" : (
            <span><ArrowsClockwise size={12} className="inline mr-1" /> Import {preview.row_count} rows</span>
          )}
        </button>
      </div>
    </div>
  );
}
